// Frameworks
import $ from "jquery";

import "@babel/polyfill";
import browserUpdate from "browser-update";

import "./NextBusWidget";
import "./JourneyPlannerWidget";

import BannerCarousel from "./components/banner-carousel";
import MobileNav from "./components/mobile-nav";
import SiteAlert from "./components/site-alert";
import TimetableSelector from "./components/timetableSelector";
import Tabs from "./components/tabs";
import Accordion from "./components/accordion";
import EventBooking from "./components/eventBooking";
import cardBalanceWidget from "./components/cardBalanceWidget";
import timetables from "./components/timetables";
import { ResponsiveTables } from "./util/tools";

// Bind jquery to the window if it isn't bound already
window.jQuery = window.jQuery || $;

/**
 * Once our DOM has loaded
 * Initialise our scripts
 */
document.addEventListener("DOMContentLoaded", () => {
  MobileNav();
  TimetableSelector();
  SiteAlert();
  BannerCarousel();
  Tabs().init();
  Accordion().init();
  EventBooking().init();
  cardBalanceWidget();
  timetables();
  ResponsiveTables();

  // Display browser update notification for out of date browsers
  // To debug and test append /#test-bu to path
  browserUpdate({
    required: {
      e: -2, // Edge last two versions
      f: -3, // Firefox last three versions
      o: -2, // Opera last two versions
      s: -2, // Safari last two versions
      c: -3 // Chrome last three versions
    },
    insecure: true
  });
});
